import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {createClickEventForPopUp} from '../../helpers/helper-popup';
import {AbstractDialogModel} from '@shared/dialogs/model/abstract-dialog.model';
import {parseUnitTextForDisplaying} from '../../helpers/unit-parsing';
import {LanguageStyleEnum} from '@core/enums/language-style.enum';
import {SettingsService} from '@shared/utils/settings.service';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';
import {TranslateService} from '@ngx-translate/core';
import {UnitInformationService} from '@shared/utils/unit-information.service';

@Component({
    selector: 'app-display-consent-text',
    templateUrl: './display-consent-text.component.html',
    styleUrls: ['./display-consent-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayConsentTextComponent implements OnInit, OnChanges {
    @Input() textToDisplay: string | undefined;
    @Input() textSize: string | undefined;
    @Input() activeOutlineTab = 0;
    @Input() hideButtonActionsForReviewer: boolean | undefined;
    @Input() commentHereButtonDisabled = false;
    @Input() initialLanguageStyle: LanguageStyleEnum | undefined;
    @Input() enableCommenting = false;
    @Input() enableEasyLanguageStyle = false;
    @Input() indicationId: string;
    @Input() hideLanguageStyleOptions = false;
    @Output() openMenu = new EventEmitter<void>();
    @Output() openDialog: EventEmitter<AbstractDialogModel> = new EventEmitter();
    @Output() selectedTab = new EventEmitter<LanguageStyleEnum>();

    languageStyleStandard = LanguageStyleEnum.STANDARD;
    languageStyleSimple = LanguageStyleEnum.SIMPLE;
    languageStyleEasy = LanguageStyleEnum.EASY;
    temporaryLanguageStyleSelected: LanguageStyleEnum | undefined;
    imageStringTag = '<img';
    fontSize: string | undefined;

    constructor(private settingsService: SettingsService, private fileRestService: FileRestService, private translate: TranslateService,
                private unitHelper: UnitInformationService) {
    }

    ngOnInit(): void {
        this.temporaryLanguageStyleSelected = this.initialLanguageStyle;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.fontSize = this.settingsService.addFontClass(this.textSize);
        if (changes.textToDisplay && this.textToDisplay) {
            if (this.textToDisplay.includes(this.imageStringTag)) {
                this.hideLanguageStyleOptions = true;
            }

            this.textToDisplay = parseUnitTextForDisplaying(this.textToDisplay);

            // TODO This should probably be refactored at some point, I couldn't find anything useful about this in the docs (Vukasin)
            setTimeout(() => {
                const pTag: any = document.querySelector('.content__text__info');
                pTag.innerHTML = this.textToDisplay;

                const images = document.querySelectorAll('.content__text .inline-image');
                this.unitHelper.getInlineImage(images);
                const videos = document.querySelectorAll('.content__text .inline-video');
                this.unitHelper.getInlineVideos(videos);

                const textPopUp = document.querySelectorAll('.content__text .popup-link');
                createClickEventForPopUp(textPopUp, this.openDialog, null);
                const multimediaPopUp = document.querySelectorAll('.content__text .multimedia-link');
                createClickEventForPopUp(multimediaPopUp, this.openDialog, this.indicationId);
                const popupLinks = document.querySelectorAll('.content__text span');
                this.setAriaLabelOnLinks(popupLinks);
            });
        }
        if (changes.initialLanguageStyle && this.initialLanguageStyle) {
            this.temporaryLanguageStyleSelected = this.initialLanguageStyle;
        }
    }

    openCommentMenu(): void {
        this.commentHereButtonDisabled = true;
        this.openMenu.emit();
    }

    selectLanguageStyle(languageStyle: LanguageStyleEnum): void {
        this.temporaryLanguageStyleSelected = languageStyle;
        this.selectedTab.emit(languageStyle);
    }

    setAriaLabelOnLinks(elements: NodeList): void {
        elements.forEach((item: any) => {
            const classAttribute = item.getAttribute('class');
            if (classAttribute === 'popup-link') {
                item.setAttribute('aria-label', item.innerHTML + ' popup link');
            } else if (classAttribute === 'multimedia-link') {
                item.setAttribute('aria-label', this.translate.instant('SCREEN_READER.IMAGE_POPUP_LINK'));
            }
        });
    }
}
